import { ButtonCommon } from "../../../../../Layout/styled";
import InputForm from "../Input";
import {
  FormStepBody,
  FormStepButtons,
  LaunchFormStep,
  StepBlockSupport,
  StepBodyBlock,
} from "../styled";
import { useState } from "react";

const LaunchProjectName = ({
  formData,
  errors,
  formValues,
  handleInputChange,
}: any) => {
  const [page, setPage] = useState(0);

  const pages = [
    formData.fields.slice(0, 5),
    formData.fields.slice(5, 10),
    formData.fields.slice(10, 16),
  ];

  const isLastPage = page === pages.length - 1;

  return (
    <LaunchFormStep>
      <FormStepBody>
        {pages[page].map((item: any, index: any) => (
          <div key={index} className="form-row">
            <StepBodyBlock>
              <h3>{item.label}</h3>
              <InputForm
                key={item.id}
                id={item.id}
                placeHolder={item.placeHolder}
                value={formValues[item.id] || ""}
                handleInputChange={handleInputChange}
                error={errors[item.id]}
              />
              {item.isSupport && Object.keys(item.isSupport).length > 0 && (
                <StepBlockSupport>
                  <p>{item.isSupport.file}</p>
                  <p>{item.isSupport.size}</p>
                </StepBlockSupport>
              )}
            </StepBodyBlock>
          </div>
        ))}
        <FormStepButtons>
          {page > 0 && (
            <button
              className="button-change-page"
              onClick={(e) => {
                setPage(page - 1);
                e.stopPropagation();
                e.preventDefault();
              }}
            >
              Back
            </button>
          )}
          {isLastPage ? (
            <ButtonCommon type="submit">Submit</ButtonCommon>
          ) : (
            <button
              className="button-change-page"
              onClick={(e) => {
                setPage(page + 1);
                e.stopPropagation();
                e.preventDefault();
              }}
            >
              Next
            </button>
          )}
        </FormStepButtons>
      </FormStepBody>
    </LaunchFormStep>
  );
};

export default LaunchProjectName;
